import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermission } from '@/hooks/use-permission';
import { useAuthStore } from '@/stores/auth-store';

interface PermissionRouteProps {
  children: React.ReactNode;
  permission: string;
  redirectTo?: string;
}

export function PermissionRoute({ 
  children, 
  permission, 
  redirectTo = '/dashboard' 
}: PermissionRouteProps) {
  const { token } = useAuthStore();
  const hasAccess = usePermission(permission);

  if (!token) {
    return <Navigate to="/login" />;
  }

  if (!hasAccess) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
